const PENDING_AUTH_EMAIL_KEY = 'pending_auth_email'
const AUTH_REDIRECT_PATH_KEY = 'auth_redirect_path'

function getStorage() {
  if (typeof window === 'undefined') return null
  return window.localStorage
}

function getSessionStorage() {
  if (typeof window === 'undefined') return null
  return window.sessionStorage
}

function normalizeValue(value: string | null | undefined) {
  const trimmed = value?.trim()
  return trimmed ? trimmed : null
}

export function persistPendingAuthEmail(email: string | null | undefined) {
  const value = normalizeValue(email)
  const storages = [getStorage(), getSessionStorage()]

  for (const storage of storages) {
    if (!storage) continue

    try {
      if (value) {
        storage.setItem(PENDING_AUTH_EMAIL_KEY, value)
      } else {
        storage.removeItem(PENDING_AUTH_EMAIL_KEY)
      }
    } catch {
      // Ignore storage access errors and continue with the next candidate.
    }
  }
}

export function readPendingAuthEmail() {
  const storages = [getStorage(), getSessionStorage()]

  for (const storage of storages) {
    if (!storage) continue

    try {
      const value = normalizeValue(storage.getItem(PENDING_AUTH_EMAIL_KEY))
      if (value) return value
    } catch {
      // Ignore storage access errors and continue with the next candidate.
    }
  }

  return null
}

export function clearPendingAuthEmail() {
  persistPendingAuthEmail(null)
}

export function persistAuthRedirectPath(path: string) {
  const normalized = normalizeValue(path)
  if (!normalized) return

  const storage = getSessionStorage()
  if (!storage) return

  try {
    storage.setItem(AUTH_REDIRECT_PATH_KEY, normalized)
  } catch {
    // Ignore storage access errors.
  }
}

export function consumeAuthRedirectPath(fallback = '/dashboard') {
  const storage = getSessionStorage()
  if (!storage) return fallback

  try {
    const stored = normalizeValue(storage.getItem(AUTH_REDIRECT_PATH_KEY))
    storage.removeItem(AUTH_REDIRECT_PATH_KEY)
    return stored ?? fallback
  } catch {
    return fallback
  }
}
